module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1556-retro.ee82ffa4.jpg";